import request from 'api/request';

export function fetchInvitation(id) {
  return request({ url: `/invitations/${id}`, method: 'GET' });
}

export function acceptInvitation(id) {
  return request({ url: `/invitations/${id}/accept`, method: 'PUT' });
}
